import React from 'react';
import { Alert } from 'flowbite-react';

interface ErrorAlertProps {
  message: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message }) => {
  return (
    <Alert color="failure">
      <span className="font-medium">Error:</span> {message}
    </Alert>
  );
};

export default ErrorAlert;
